var _style, _g, _g2, _g3, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 878.6 497",
    style: {
      enableBackground: "new 0 0 878.6 497"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.24;}\n\t.st1{fill:#F1F1F1;}\n\t.st2{opacity:0.85;}\n\t.st3{fill:#CACACA;}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#E6E6E6;}\n\t.st6{opacity:0.76;}\n\t.st7{fill:#E7A39D;}\n\t.st8{fill:#2F2E41;}\n\t.st9{fill:#F47B49;}\n\t.st10{fill:#EDA79B;}\n\t.st11{fill:#FBBEBE;}\n\t.st12{fill:#3F3D56;}\n\t.st13{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,426.7c-19.5,14.5-25,40.1-25,40.1s26.1,2,45.6-12.5s25-40.1,25-40.1S153.5,412.2,134,426.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,433.5c-9.4,22.5-32.9,34-32.9,34s-8.3-24.8,1.1-47.3s32.9-34,32.9-34S151.5,411.1,142.2,433.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "878.6,463.7 0,463.7 0,490.7 52,490.7 52,497 826.7,497 826.7,490.7 878.6,490.7  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M703.5,368.6L703.5,368.6c-2.1-14-2.6-28.1-1.6-42.2l1.6-23.3l0,0C694.5,321,696.5,344.6,703.5,368.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M710.5,372.5L710.5,372.5c-1-8.3-1.3-16.7-0.8-25.1l0.8-13.9l0,0C706.2,344.2,707.2,358.2,710.5,372.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M741.7,389.7v7.8c0,1.3-1.1,2.3-2.3,2.3h-3.9c-0.4,0-0.8,0.3-0.8,0.8l0,0v63.9c0,1.3-1.1,2.3-2.3,2.3h-47.6 c-1.3,0-2.3-1-2.3-2.3v-63.9c0-0.4-0.3-0.8-0.8-0.8H677c-1.3,0-2.3-1-2.3-2.3v-7.8c0-1.3,1-2.3,2.3-2.3l0,0h62.4 C740.7,387.3,741.7,388.4,741.7,389.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.5,
    y: 401.4,
    className: "st5",
    width: 52.2,
    height: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M734.7,435.9c-17.5,7.2-35.2,7.3-53,0v-16.5c17.2-5.8,35.8-5.8,53,0V435.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "fff0188c-9915-4c0d-8339-9317a77083e8",
    className: "st7",
    cx: 441.9,
    cy: 99.2,
    r: 70.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac220ed6-7c3f-4d1e-8d82-3295770c496a-510",
    className: "st8",
    d: "M507.9,38.2C497.3,21,480.8,8.4,461.5,2.7L452.8,9V0.9 c-4.6-0.7-9.3-1-14-0.8l-7.5,6.8V0.6c-22.4,2.8-42.6,14.8-55.8,33.2c-16.3,23.4-19,56-3,79.7c4.4-13.5,9.7-26.1,14.1-39.6 c3.4,0.5,6.9,0.5,10.4,0.1l5.3-12.5l1.5,11.9c16.5-1.4,41.1-4.6,56.8-7.5l-1.5-9.2l9.1,7.6c4.8-1.1,7.7-2.1,7.4-2.9 c11.7,18.8,25.9,30.8,37.6,49.6C517.7,84.5,522.8,62.5,507.9,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M593.8,280.9c-2.4-14.6-4.9-29.5-11.7-42.7c-4.5-8.6-11.6-16.8-21.1-18.6c-1.9-0.2-3.7-0.6-5.5-1.3 c-2.8-1.3-40.4-22.8-46.4-26.6c-5.1-3.2-13.2-9.2-17.3-9.2c-4.1-0.1-19.9,3.6-81.4-1.2c0,0-16.9,6.7-30,14.7 c-0.2-0.1-63.9,34.1-66.3,34c-4.5-0.2-8.7,2.7-11.3,6.4c-2.6,3.7-3.8,8.2-5.1,12.5c13.9,31,26.6,62,40.5,92.9c0.7,1.2,1,2.5,1,3.8 c-0.3,1.4-0.9,2.7-1.7,3.8c-6.8,11-6.6,24.7-5.9,37.6s1.7,26.5-4.1,38c-1.6,3.2-3.6,6.1-5.1,9.2c-3.5,7.2-4.7,30.1-2.7,37.8 l255.1,7.3C569.4,464.6,593.8,280.9,593.8,280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb46eb08-8e3e-4ac5-913b-26d221d967b9-511",
    className: "st10",
    d: "M275.6,343.4c-0.5,3.7-0.6,7.4-0.2,11.1l3.7,52.5 c0.3,4.9,0.7,9.9,1.1,14.8c0.9,9.6,2.2,19.1,3.8,28.6c0.1,2.8,2.4,5,5.2,4.9c16.1,3.4,32.7,3.3,49.2,2.3c25.1-1.4,89.2-4,93.1-9.1 s1.6-13.3-3.5-17.4S338.4,417,338.4,417c0.8-6.6,3.3-12.7,5.7-18.9c4.3-11,8.2-22.4,8.3-34.3s-4.4-24.2-14.1-31 c-8-5.6-18.2-6.6-27.9-6.4c-7.1,0.2-19.3-1.5-25.7,1.3C279.5,329.9,276.6,338.4,275.6,343.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "efe93a1e-ccdd-49fd-af5f-e26394aa0937-512",
    className: "st9",
    d: "M296.9,250c-1.2,1.3-2.2,2.8-2.8,4.5 c-10.3,23.2-16.4,48-17.9,73.3c0,1.2-0.3,2.5-0.8,3.6c-0.6,0.7-1.2,1.4-1.9,2c-2.5,3-2.1,7.4,0.8,9.9l0,0c0.1,0.1,0.2,0.2,0.4,0.3 c2.1-4,7.1-5.2,11.6-5.6c21.4-1.7,42.3,8.3,63.7,7.5c-1.5-5.2-3.7-10.3-4.9-15.5c-5.5-23.5,8.2-49.1-0.2-71.7 c-1.7-4.5-4.5-9-8.8-11c-1.8-0.7-3.7-1.2-5.7-1.5c-5.4-1-16.2-5.2-21.5-3.5c-1.9,0.6-2.7,2.4-4.3,3.5 C302.2,247.4,299,248,296.9,250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a38c3c09-000b-42b7-8619-0229d8aff5e9-513",
    className: "st10",
    d: "M594,327.7c-6.5-2.8-18.7-1.1-25.7-1.3 c-9.7-0.2-20,0.8-27.9,6.4c-9.7,6.8-14.1,19.2-14.1,31s4,23.2,8.3,34.3c2.4,6.2,4.9,12.4,5.7,18.9c0,0-84.6,10-89.7,14.1 s-7.4,12.3-3.5,17.4s126.2,10.2,142.3,6.8c2.8,0.1,5.1-2.1,5.2-4.9c1.6-9.5,2.9-19,3.8-28.6c0.5-4.9,0.8-9.9,1.1-14.8l3.7-52.5 c0.4-3.7,0.4-7.4-0.2-11.1C602.1,338.4,599.1,329.9,594,327.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd3879bf-5d05-49be-b690-c4d97e29a2ab-514",
    className: "st9",
    d: "M574,245.8c-1.6-1.1-2.4-2.9-4.3-3.5c-5.2-1.7-16,2.5-21.5,3.5 c-1.9,0.3-3.8,0.8-5.7,1.5c-4.4,2-7.2,6.4-8.8,11c-8.3,22.6,5.3,48.2-0.2,71.7c-1.2,5.3-3.4,10.3-4.9,15.5 c21.5,0.8,42.3-9.2,63.7-7.5c4.5,0.3,9.5,1.6,11.6,5.6c0.1-0.1,0.2-0.2,0.4-0.3c3-2.5,3.3-6.9,0.8-9.9l0,0c-0.7-0.6-1.3-1.3-1.9-2 c-0.6-1.1-0.9-2.3-0.8-3.6c-1.6-25.3-7.7-50.1-17.9-73.3c-0.6-1.7-1.6-3.2-2.8-4.5C579.7,248,576.4,247.4,574,245.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 420.9,
    cy: 438.8,
    r: 19.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 463.2,
    cy: 438.8,
    r: 19.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M376.9,125.5L376.9,125.5c-11.4,0-20.6-10-20.6-22.2l0,0V92.2c0-12.3,9.2-22.2,20.6-22.2l0,0V125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M508.1,70L508.1,70c11.4,0,20.6,10,20.6,22.2v11.1c0,12.3-9.2,22.2-20.6,22.2l0,0V70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M518.9,94h-3.3c0-44.7-33.7-81.1-75-81.1c-41.4,0-75,36.4-75,81.1h-3.3c0-46.7,35.1-84.6,78.3-84.6 C483.7,9.3,518.9,47.3,518.9,94z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M580.9,481.8h-262c-6.4,0-11.5-5.2-11.5-11.5v-159c0-6.4,5.2-11.5,11.5-11.5h262c6.4,0,11.5,5.2,11.5,11.5v159 C592.4,476.6,587.3,481.8,580.9,481.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "bf1cdf42-3b4f-4239-91c9-f6802a29e918",
    className: "st13",
    cx: 449.2,
    cy: 390.8,
    r: 7.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.c153d6f41e40bcb788fdfb084496d2e7.svg";
export { ForwardRef as ReactComponent };